import {
  BoardIcon,
  ClipboardIcon,
  CreationIcon,
  DocumentIcon,
  LessonIcon,
  SketchNoteLogoIcon,
} from '@sketchnote/icons';
import { ActionArrowRightIcon } from '@sketchnote/icons';
import { ComingSoonTag } from '@sketchnote/shared-components';

export const navigations: { label: string; value: any }[] = [
  // {
  //   label: 'Feedback',
  //   value: 'feedback'
  // },
  // {
  //   label: 'Bug report',
  //   value: 'bug-report'
  // },
  {
    label: 'Shortcuts',
    value: 'shortcuts',
  },
  // {
  //   label: 'Reset onboarding',
  //   value: 'reset-onboarding'
  // }
];

export const demos = [
  {
    label: 'Workstation dashboard',
    value: 'workstation-dashboard',
    icon: SketchNoteLogoIcon,
    title: 'Workstation dashboard walkthrough',
    description: 'demo_lesson_description',
    videoId: '4k2r74x82Dg',
    thumbnailUrl:
      'https://res.cloudinary.com/samvibes/image/upload/academy/workstation_walkthrough.png',
  },
  {
    label: 'Academy dashboard',
    value: 'academy-dashboard',
    icon: LessonIcon,
    title: 'Academy dashboard walkthrough',
    description: 'demo_lesson_description',
    videoId: 'SgClZ98wTxM',
    thumbnailUrl: 'https://res.cloudinary.com/samvibes/image/upload/academy/walkthrough.png',
  },
  {
    label: 'Files',
    value: 'files',
    icon: CreationIcon,
    title: 'Files walkthrough',
    videoId: 'eXNIc9oh7h4',
    description: 'demo_creation_description',
    thumbnailUrl: 'https://res.cloudinary.com/samvibes/image/upload/academy/file_walkthrough.png',
  },
];
export const actionLinks: { label: string; href?: any; icon: JSX.Element }[] = [
  { label: 'Help Center', href: '/help', icon: <ActionArrowRightIcon /> },
  { label: 'Community', href: 'https://community.sketchnote.co', icon: <ActionArrowRightIcon /> },
];

export const shortcutSections = [
  {
    title: 'General',
    bindings: [
      {
        label: 'Go to Dashboard',
        keys: ['cmd/ctrl', 'shift', 'D'],
      },
      {
        label: 'Go to Catalog',
        keys: ['cmd/ctrl', 'shift', 'C'],
      },
      {
        label: 'Open Settings',
        keys: ['cmd/ctrl', 'shift', 'S'],
      },
      // {
      //   label: 'Start new document',
      //   keys: ['N', 'D']
      // },
      // {
      //   label: 'Start new board',
      //   keys: ['+', 'B']
      // },
      {
        label: 'Open Help',
        keys: ['cmd/ctrl', 'shift', 'H'],
      },
      {
        label: 'General Searcg',
        keys: ['cmd/ctrl', 'P'],
      },
      {
        label: 'Semantic Search',
        keys: ['cmd/ctrl', 'F'],
      },
      {
        label: 'Next page',
        keys: ['cmd/ctrl', '['],
      },
      {
        label: 'Previous page',
        keys: ['cmd/ctrl', ']'],
      },
      // {
      //   label: 'Move between items',
      //   keys: ['', 'H']
      // },
      // {
      //   label: 'Open selected item',
      //   keys: ['return/enter']
      // }
    ],
  },
  {
    title: 'Learn',
    bindings: [
      {
        label: 'Open Help',
        keys: ['cmd/ctrl', 'shift', 'H'],
      },
      {
        label: 'Bookmark',
        keys: ['cmd/ctrl', 'shift', 'B'],
      },
      {
        label: 'Audio play/pause ',
        keys: ['Spacebar'],
      },
      {
        label: 'Next page',
        keys: ['cmd/ctrl', '['],
      },
      {
        label: 'Previous page',
        keys: ['cmd/ctrl', ']'],
      },
    ],
  },
  // {
  //   title: 'Format',
  //   bindings: [
  //     {
  //       label: 'Bold',
  //       keys: ['⌘', 'B']
  //     },
  //     {
  //       label: 'Cursiva',
  //       keys: ['⌘', 'I']
  //     },
  //     {
  //       label: 'Underline',
  //       keys: ['⌘', 'U']
  //     },
  //     {
  //       label: 'Add link to text',
  //       keys: ['⌘', 'K']
  //     }
  //   ]
  // },
  // {
  //   title: 'Insert',
  //   bindings: [
  //     {
  //       label: 'Heading 1',
  //       keys: ['H', '/', '1']
  //     },
  //     {
  //       label: 'Heading 2',
  //       keys: ['H', '/', '2']
  //     },
  //     {
  //       label: 'Heading 3',
  //       keys: ['H', '/', '3']
  //     },
  //     {
  //       label: 'Quote',
  //       keys: ['⌥', '⌘', 'Q']
  //     },
  //     {
  //       label: 'Code',
  //       keys: ['⌥', '⌘', 'C']
  //     },
  //     {
  //       label: 'To do list',
  //       keys: ['⌥', '⌘', 'T']
  //     },
  //     {
  //       label: 'Bulleted list',
  //       keys: ['⌥', '⌘', 'B']
  //     },
  //     {
  //       label: 'Numbered list',
  //       keys: ['⌥', '⌘', 'N']
  //     },
  //     {
  //       label: 'Nueva linea (salto)',
  //       keys: ['⇧', 'Intro']
  //     }
  //   ]
  // },
  // {
  //   title: 'Editor',
  //   bindings: [
  //     {
  //       label: 'Open weapon list',
  //       keys: ['/']
  //     },
  //     {
  //       label: 'Comment',
  //       keys: ['⌥', 'C']
  //     },
  //     {
  //       label: 'Presentation view',
  //       keys: ['⌥', 'P']
  //     },
  //     {
  //       label: 'Copy',
  //       keys: ['⌘', 'C']
  //     },
  //     {
  //       label: 'Paste',
  //       keys: ['⌘', 'V']
  //     },
  //     {
  //       label: 'Undo',
  //       keys: ['⌘', 'Z']
  //     },
  //     {
  //       label: 'Redo',
  //       keys: ['⌘', 'Y']
  //     },
  //     {
  //       label: 'Select all',
  //       keys: ['⌘', 'A']
  //     },
  //     {
  //       label: 'Save edits',
  //       keys: ['⌘', 'S']
  //     }
  //   ]
  // },
  // {
  //   title: 'Weapons',
  //   bindings: [
  //     {
  //       label: 'Heading 1',
  //       keys: ['H', '/', '1']
  //     },
  //     {
  //       label: 'Heading 2',
  //       keys: ['H', '/', '2']
  //     },
  //     {
  //       label: 'Heading 3',
  //       keys: ['H', '/', '3']
  //     },
  //     {
  //       label: 'Quote',
  //       keys: ['⌥', '⌘', 'Q']
  //     },
  //     {
  //       label: 'Code',
  //       keys: ['⌥', '⌘', 'C']
  //     },
  //     {
  //       label: 'To do list',
  //       keys: ['H', '/', '1']
  //     },
  //     {
  //       label: 'Bulleted list',
  //       keys: ['H', '/', '1']
  //     },
  //     {
  //       label: 'Numbered list',
  //       keys: ['H', '/', '1']
  //     },
  //     {
  //       label: 'Nueva linea (salto)',
  //       keys: ['H', '/', '1']
  //     }
  //  ]
  //  }
];
